import React, { useCallback, useContext } from "react";
import { MoneyContext } from "../../Grandpa";

const Sister = () => {
  const [money, setMoney] = useContext(MoneyContext);
  return (
    <div>
      <h4>Sister</h4>
      <p>Money: {money}</p>
      <button onClick={() => setMoney(money + 1000)}>Money</button>
    </div>
  );
};

export default Sister;
